'use client'

import type { Address } from 'viem'

import { type ButtonProps, MultiSelect } from '@repo/ui'
import { type Token, TokenIcon } from '@repo/web3'

interface TokenMultiSelectProps {
  label: string
  options: Token[]

  values: Address[]
  setValues: (values: Address[]) => void
  triggerVariant?: ButtonProps['variant']
}

export function TokenMultiSelect({
  options,
  label,
  values,
  setValues,
  triggerVariant
}: TokenMultiSelectProps) {
  'use memo'

  return (
    <MultiSelect
      label={label}
      options={options.map(o => ({
        value: o.address,
        keywords: [o.name, o.symbol],
        component: (
          <div className="flex items-center gap-2">
            <TokenIcon size="xs" symbol={o.symbol} logoUrl={o.logoUrl} />
            <span>{o.name}</span>
          </div>
        )
      }))}
      values={values}
      onChange={values => setValues(values as Address[])}
      triggerVariant={triggerVariant}
    />
  )
}
